import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environment/environment';
import { restEndPoints } from '../../app.constants';
import { BehaviorSubject, map, Observable, Subject } from 'rxjs';
import {BookingDetails, BookingsData, IBookingDetailsResponse, IBookingsGridResponse } from './booking.models';
import { DateConverterService } from '../../helpers/date-converter.service'

@Injectable({
  providedIn: "root",
})
export class BookingService {
  baseUrl = environment.apiHost;
  authToken: string | null = "";
  bookingOverviewDetails = new BehaviorSubject<BookingDetails | null>(null);

  constructor(
    private httpClient: HttpClient,
    private dateConverterService: DateConverterService,
  ) {}

  getAllBookingOverview(body: any): Observable<any[]> {
    const payload = {
      companyId: body.companyId,
      CategoryIds: body.CategoryIds,
      StoreIds: body.StoreIds,
      Statuses: body.Statuses,
      startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.startDate,
      ),
      endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.endDate,
        true,
      ),
      pageOffset: body.pageOffset,
      pageLimit: body.pageLimit,
    };
    const url = `${this.baseUrl}${restEndPoints.bookings.getAllBookingData}`;
    return this.httpClient.post<any>(url, payload).pipe(
      map((response: any) => {
        if (!response.isError) {
          return response.value || [];
        } else {
          return [];
        }
      }),
    );
  }

  getAllSortBookingOverview(body: any): Observable<IBookingsGridResponse> {
    const payload = {
      companyId: body.companyId,
      CategoryIds: body.CategoryIds,
      StoreIds: body.StoreIds,
      Statuses: body.Statuses,
      startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.startDate,
      ),
      endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.endDate,
        true,
      ),
      pageLimit: body.pageLimit,
    };
    const url = `${this.baseUrl}${restEndPoints.bookings.getBookingSortingDetails}?pageOffset=${body.pageOffset}&columnName=${body.columnName}&sortOrder=${body.sortOrder}&execDateflag=${body.execDateflag}`;
    return this.httpClient.post<IBookingsGridResponse>(url, payload);
  }

  getAllBookingOverviewCount(body: any): Observable<number> {
    const payload = {
      companyId: body.companyId,
      CategoryIds: body.CategoryIds,
      StoreIds: body.StoreIds,
      Statuses: body.Statuses,
      startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.startDate,
      ),
      endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.endDate,
        true,
      ),
      pageOffset: body.pageOffset,
      pageLimit: body.pageLimit,
    };

    const url = `${this.baseUrl}${restEndPoints.bookings.getAllBookingDataCount}?execDateflag=${body.execDateflag}`;
    return this.httpClient.post<any>(url, payload).pipe(
      map((response: any) => {
        if (!response.isError) {
          return response.value;
        } else {
          return [];
        }
      }),
    );
  }

  getBookingDetailsByTask(taskid: number, companyId: number) {
    const url = `${this.baseUrl}${restEndPoints.bookings.getBookingDetailsByTaskId}/${taskid}/${companyId}`;
    return this.httpClient.get<IBookingDetailsResponse>(url).pipe(
      map((response: IBookingDetailsResponse) => {
        if (!response.isError) {
          return response.value;
        } else {
          throw new Error("Error fetching data");
        }
      }),
    );
  }

  getImagesofDeclaration(taskid: number, companyId: number) {
    const url = `${this.baseUrl}${restEndPoints.bookings.getBookingsImagesByTaskId}/${taskid}/${companyId}`;
    return this.httpClient.get<any>(url).pipe(
      map((response: any) => {
        if (!response.isError) {
          return response.value;
        } else {
          return [];
        }
      }),
    );
  }

  
}
